// item 482 — a persistent in-app notification (the sidebar "until read" feed).
export enum NotificationType {
  General = 0,
  TaskAssigned = 1,
  Commission = 2,
  TaskCompleted = 3,
  ExtraPayApproved = 4,
  ExtraPayEntered = 5,
  InvoiceFinalized = 6,
  ExtraPaySubmitted = 7,
  ExtraPayDeclined = 8, // item 537 — a submitted commission/timesheet was declined (sent back)
  PaymentFailed = 9, // item 581 — a Stripe payment attempt failed (accountant audience)
  PaymentRefunded = 10, // item 581 — a Stripe payment was refunded (accountant audience)
  PaymentReceived = 11, // item 583 — a payment was received, Stripe or manual (accountant audience)
  SalesOrderApproved = 12, // item 1402 — the customer approved a sales order in the portal (convert it)
  SalesOrderDeclined = 13, // item 1402 — the customer declined a sales order in the portal
}

export interface AppNotification {
  id: string;
  type: NotificationType;
  title: string;
  body: string;
  link: string;
  isRead: boolean;
  createdDate: string;
}

// the short tag shown in brackets on the feed pill, e.g. [new commission]
export const NOTIFICATION_TAG: Record<NotificationType, string> = {
  [NotificationType.General]: 'notice',
  [NotificationType.TaskAssigned]: 'task assigned',
  [NotificationType.Commission]: 'new commission',
  [NotificationType.TaskCompleted]: 'task done',
  [NotificationType.ExtraPayApproved]: 'extra pay',
  [NotificationType.ExtraPayEntered]: 'payroll',
  [NotificationType.InvoiceFinalized]: 'to enter',
  [NotificationType.ExtraPaySubmitted]: 'to approve',
  [NotificationType.ExtraPayDeclined]: 'declined',
  [NotificationType.PaymentFailed]: 'payment failed',
  [NotificationType.PaymentRefunded]: 'refunded',
  [NotificationType.PaymentReceived]: 'payment received',
  [NotificationType.SalesOrderApproved]: 'SO approved',
  [NotificationType.SalesOrderDeclined]: 'SO declined',
};

export const NOTIFICATION_SCHEME: Record<NotificationType, string> = {
  [NotificationType.General]: 'gray',
  [NotificationType.TaskAssigned]: 'blue',
  [NotificationType.Commission]: 'green',
  [NotificationType.TaskCompleted]: 'purple',
  [NotificationType.ExtraPayApproved]: 'orange',
  [NotificationType.ExtraPayEntered]: 'teal',
  [NotificationType.InvoiceFinalized]: 'blue',
  [NotificationType.ExtraPaySubmitted]: 'red',
  [NotificationType.ExtraPayDeclined]: 'red',
  [NotificationType.PaymentFailed]: 'red',
  [NotificationType.PaymentRefunded]: 'orange',
  [NotificationType.PaymentReceived]: 'green',
  [NotificationType.SalesOrderApproved]: 'green',
  [NotificationType.SalesOrderDeclined]: 'red',
};
